import React from 'react';
import { FolderItem } from '../shared/FolderItem';
import { useDispatch, useSelector, batch } from 'react-redux';
import { navigatingFolders } from '../../actions/folders';
import { isChangingEmailSaveLocation } from '../../actions/mail';
import { setFileSaveState } from '../../actions/files';
import PropTypes from 'prop-types';
import { PlusSign } from '../shared/PlusSign';
import { changeAlertText } from '../../actions/index';
import { useState } from 'react';
import { FolderIcon } from './FolderIcon';
import './NavigateFolder.scss';

export const NavigateFolder = ({ folder, updateBrowsingFolderCallback, clearSearchCallback, showSelectFolder = false, isRoot, isSearchingFiles, selectedRecord }) => {
  const dispatch = useDispatch();
  const folderName = folder?.name;

  const containsFiles = useSelector((state) => state.files?.fileMaps?.[selectedRecord.Id]?.[folder?.path] !== undefined);
  const isComposingEmail = useSelector((state) => state.mail.isComposingEmail);
  const folderHasFiles = !!folder?.subfolders?.length || (containsFiles && isComposingEmail);
  const folderHasSubfolder = !!folder?.subfolders?.length;
  const className = folderHasSubfolder || (folderHasFiles && isSearchingFiles) ? 'navigate-folder-content-active' : 'navigate-folder-content-inactive';
  const [itemHover, setItemHover] = useState(false);
  const currentFileId = useSelector((state) => state.files.currentFileId);
  const docrioFile = useSelector((state) => state.files.docrioFiles.find((file) => file.id === currentFileId));
  const folderPaths = docrioFile?.folderPaths || [];

  const handleContentOnClick = () => {
    // diving into folder is contingent on contained subfolders in compose mode.
    if (folderHasSubfolder || (isSearchingFiles && folderHasFiles)) {
      updateBrowsingFolderCallback(folder.path);
      clearSearchCallback('');
    }
  };

  const handleSaveFolder = () => {
    // Implies being set to a root folder or a path with a root of ''
    batch(() => {
      folderPaths[selectedRecord.Id] = folder;
      dispatch(setFileSaveState(true, { itemId: docrioFile.id, name: docrioFile.name, folderPaths, selectedRecordId: selectedRecord.Id }));
      dispatch(changeAlertText('Folder Successfully Changed'));
      dispatch(navigatingFolders(false));
      dispatch(isChangingEmailSaveLocation(false));
    });
  };
  const center = <p className={`${className} ${isRoot && 'navigate-folder-root'}`} onClick={handleContentOnClick}>{isRoot ? `Save File to ${folderName}` : folderName}</p>;
  const button = showSelectFolder && <PlusSign clickAction={handleSaveFolder} isHoveringParent={itemHover} />;

  return (
    <div id={folder?.name} onMouseEnter={() => setItemHover(true)} onMouseLeave={() => setItemHover(false)}>
      <FolderItem image={!isRoot ? <FolderIcon folderHasContent={folderHasSubfolder || (isSearchingFiles && folderHasFiles)} /> : <></>} content={center} button={button} className={'navigate-folder-container'} />
    </div>
  );
};

NavigateFolder.propTypes = {
  folder: PropTypes.object,
  updateBrowsingFolderCallback: PropTypes.func,
  clearSearchCallback: PropTypes.func,
  showSelectFolder: PropTypes.bool,
  isRoot: PropTypes.bool,
  isSearchingFiles: PropTypes.bool,
  selectedRecord: PropTypes.object,
};

